import { createTheme } from "@mui/material/styles";

const NAVY = "#1a3b8e";
const TEAL = "#0d9488";
const TEAL_DARK = "#2dd4bf";

const palettes = {
  light: {
    mode: "light",
    primary: { main: NAVY },
    secondary: { main: TEAL },
    background: {
      default: "#f8fafc",
      paper: "#ffffff",
      subtle: "#f8fafc",
    },
    divider: "#e2e8f0",
    text: {
      primary: "#1e293b",
      secondary: "#64748b",
    },
  },
  dark: {
    mode: "dark",
    primary: { main: TEAL_DARK },
    secondary: { main: TEAL_DARK },
    background: {
      default: "#0b1220",
      paper: "#101a2e",
      subtle: "#0e1729",
    },
    divider: "#334155",
    text: {
      primary: "#f1f5f9",
      secondary: "#94a3b8",
    },
  },
};

export const getTheme = (mode, gridLocale) =>
  createTheme(
    {
      palette: palettes[mode] ?? palettes.light,
      shape: { borderRadius: 8 },
      components: {
        MuiCssBaseline: {
          styleOverrides: (theme) => ({
            body: { backgroundColor: theme.palette.background.default },
          }),
        },
      },
    },
    gridLocale
  );
